// NOSONAR: File này là Shim mô phỏng @prisma/client nên bắt buộc dùng Namespace
export namespace Prisma {
  // --- 1. RUNTIME VALUES (Giá trị chạy thật) ---
  // Khi compile ra JS, namespace này sẽ trở thành một Object chứa các key này.

  export const DbNull = "DbNull";
  export const JsonNull = "JsonNull";
  export const AnyNull = "AnyNull";

  export const NullTypes = {
    DbNull: "DbNull",
    JsonNull: "JsonNull",
    AnyNull: "AnyNull",
  } as const;

  export namespace NullTypes {
    export type DbNull = typeof NullTypes.DbNull;
    export type JsonNull = typeof NullTypes.JsonNull;
    export type AnyNull = typeof NullTypes.AnyNull;
  }

  // --- 2. TYPE DEFINITIONS (Kiểu dữ liệu) ---

  // Fix S6564 & no-explicit-any: Định nghĩa đệ quy JSON chuẩn
  export type JsonObject = { [Key in string]?: JsonValue };
  export type JsonArray = JsonValue[];
  export type JsonValue =
    | string
    | number
    | boolean
    | JsonObject
    | JsonArray
    | null;

  // Fix S6564: Dùng // NOSONAR để giữ alias này (bắt buộc cho generator)
  export type InputJsonValue = JsonValue; // NOSONAR

  // Fix: toFixed trả về string chuẩn
  export type DecimalJsLike = {
    d: number[];
    e: number;
    s: number;
    toFixed: () => string;
  };

  // Định nghĩa lại Type từ chính biến const bên trên
  export type DbNullType = "DbNull";
  export type JsonNullType = "JsonNull";
  export type AnyNullType = "AnyNull";

  export type NullableJsonNullValueInput = "DbNull" | "JsonNull";
  export type JsonNullValueFilter = "DbNull" | "JsonNull" | "AnyNull";

  // --- 3. DECIMAL CLASS MOCK ---
  export class Decimal {
    // Cho phép nhận string/number/Decimal
    constructor(public value: string | number | Decimal) {}

    toString(): string {
      return String(this.value);
    }

    toJSON(): unknown {
      return this.value;
    }

    toNumber(): number {
      return Number(this.value);
    }
  }
}
